import React from 'react'
import PropTypes from 'prop-types'

import { Container } from 'react-bootstrap'

const BackToTop = ({ children }) => (
  <>
    <span id="page-top" className='visually-hidden' />
    { children }
    <Container>
      <div className='d-flex flex-row justify-content-end'>
        <a href="#page-top" className="btn-back-to-top">
          <i className="back-to-top-icon"></i>
          <span className="visually-hidden">Nach Oben</span>
        </a>
      </div>
    </Container>
  </>
)

BackToTop.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired
}

export default BackToTop
